import React from "react";
import clsx from "clsx";
type Props = { item: any };

const ManufactureOrderStatus = ({ item }: Props) => {
  return (
   <div className="flex w-full justify-center items-center">
     <div
      className={clsx(
        "w-4 h-4 rounded-full",
        item?.status == "پیش نویس" && "bg-yellow-1",
        item?.status == "تایید شده" && "bg-[#24AF22]",
        !item?.status && "bg-slate-500"
      )}
    />
   </div>
  );
};

export default ManufactureOrderStatus;
